/** 列舉 Confirm 頁的三個步驟 */
export enum LoginStep {
  LOGIN_OR_SIGNUP = 0,
  LOGIN = 1,
  SIGNUP = 2,
}

export default LoginStep
